(() => {
  let loaded = false;
  function start() {
    const privacy = window.Shopify?.customerPrivacy;
    const consent = privacy?.currentVisitorConsent();
    if (loaded || consent?.analytics !== 'yes' || consent?.marketing !== 'yes' ||
        !privacy.analyticsProcessingAllowed() || !privacy.marketingAllowed()) return;
    loaded = true;
    // An existing Whop installation already owns storefront page tracking.
    if (window.whop) return;
    !function(w,d,s,u,n,a,b){if(w[n])return;a=w[n]={q:[],t:+new Date,s:[],o:u,track:function(){a.q.push([+new Date].concat([].slice.call(arguments)))},setScope:function(){a.s=[].slice.call(arguments).filter(function(x){return typeof x==="string"});a.q.push([+new Date,"setScope"].concat(a.s))},scope:function(){var c=[].slice.call(arguments);return{track:function(){a.q.push([+new Date].concat([].slice.call(arguments)).concat([{__scope:c}]))}}}};b=d.createElement(s);b.async=1;b.src=u+"/s.js";d.getElementsByTagName(s)[0].parentNode.insertBefore(b,d.getElementsByTagName(s)[0])}(window,document,"script","https://t.whop.tw","whop");
    window.whop.setScope('biz_G4xbYdg1WCDHzY');
    window.whop.track('page');
  }
  document.addEventListener('visitorConsentCollected', start);
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) start();
  });
})();
